











import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { LineStyle, Color, PaintStyle, TextStyle, Rectangle } from "../../../../../../../base/domain/drawing";
import { TextAreaEditor } from "../../../../../../../base/components/drawing/drawers";
import { IConfiguration, ObjectKeys, IFormatEditorStyleFormatEditorObjectConfiguration } from "../../../../../../domain/configuration";

@Component({
  components: {
    TextAreaEditor,
  },
})
export default class ConfiguredTextAreaEditor extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  readonly: boolean;

  @Prop()
  rectangle: Rectangle;

  @Prop()
  borderStyle: LineStyle;

  @Prop()
  paintStyle: PaintStyle;

  @Prop()
  textStyle: TextStyle;

  @Prop()
  configurationKey: ObjectKeys;

  $configuration!: IConfiguration;

  get configuration(): IFormatEditorStyleFormatEditorObjectConfiguration {
    return this.$configuration.formatEditor.style.format.editor.objects[this.configurationKey];
  }

  get isConfigured(): boolean {
    return !!this.configuration;
  }

  get configuredBorderStyle(): LineStyle {
    return new LineStyle(
      this.isConfigured ? new Color(this.configuration.borderColorCode) : this.borderStyle.color, 
      this.borderStyle.kind,
      this.borderStyle.width);
  }

  get configuredPaintStyle(): PaintStyle {
    return new PaintStyle(
      this.isConfigured ? new Color(this.configuration.backgroundColorCode) : this.paintStyle.color, 
      this.paintStyle.kind);
  }

  get configuredTextStyle(): TextStyle {
    return new TextStyle(
      this.isConfigured ? new Color(this.configuration.foregroundColorCode) : this.textStyle.color, 
      this.textStyle.textAlign,
      this.textStyle.baseFontSize,
      this.textStyle.adjustedFontSize,
      this.textStyle.fontFamily,
      this.textStyle.lineHeight,
      this.textStyle.isMultiLine);
  }
}
